/// <amd-module name="VSS/Fabric/Theming" />
import { IVssPageContext, IVssPersistantService, ServiceOptions, Services, VssService } from "VSS/Platform/Context";
import { IVssThemeService } from "VSS/Platform/Theming";
import { setFabricTheme } from "./FabricThemeUtil";

/**
 * OfficeFabric uses a similar theming system where they map logical names to colors.
 * We need to tell OfficeFabric about the current theme when it changes.
 */
class FabricThemeService extends VssService implements IVssPersistantService {
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);

        // Signup for theme changes so we can keep the office fabric theme up to date.
        const themeService = this.pageContext.getService<IVssThemeService>("IVssThemeService");
        themeService.subscribe(this._initializeFabricTheme, "themeChanged");

        // Initialize the fabric theme now that we are setup.
        this._initializeFabricTheme();
    }

    private _initializeFabricTheme = (): void => {
        const themeService = this.pageContext.getService<IVssThemeService>("IVssThemeService");
        const theme = themeService.getCurrentTheme();
        if (theme) {
            setFabricTheme(theme.data);
        }
    };
}

Services.add("IVssFabricService", { serviceFactory: FabricThemeService, options: ServiceOptions.Persistant | ServiceOptions.Startup });
